import angular from 'angular';
import { AddAccountService } from './add-account.service.js';

angular.module('parameters.add-account', [])
  .factory('AddAccountFactory', AddAccountService.AddAccountFactory);
